import { Modal } from "@mui/material";
import {
    ReactElement,
    HTMLAttributes
} from "react";
interface Props extends HTMLAttributes<HTMLElement> {
    openModal: boolean;
    children: ReactElement,
    onClose?: any;
    myStyle?:string
}

export function CustomModal({ openModal, onClose, children , myStyle }: Props): ReactElement {
    return (
        <Modal
            open={openModal}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
             <div className={`${myStyle && myStyle } custom-modal`}>
            {children}</div>

        </Modal>
    );
}

export default CustomModal;